<template>
  <div>
    <div class="chinaMap" ref="chinaMap" style="width: 100%;height: 650px;"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
import 'echarts/map/js/china'
import autoResize from "@jiaminghi/data-view/lib/mixin/autoResize";
export default {
  name: 'flyMap',
  mixins: [autoResize],
  data() {
    return {
    }
  },
  mounted() {
    this.initCharts()
  },
  methods: {
    initCharts() {
      let mapcharts = echarts.init(this.$refs.chinaMap);
      // 绘制图表
      mapcharts.setOption({
        series: [{
          type: 'map',
          map: 'china',
          // layoutCenter: ['50%', '50%'], // 地图布局中心点
          layoutSize: 700,
          top: '5%',
          label: {
            show: true,
            color: '#ffffff',
            fontSize: 16,
          },
          itemStyle: {
            areaColor: '#eee',
            borderColor: '#24dafe',
            emphasis: {
              areaColor: '#ffcc00' // 选中时的颜色
            }
          },
          roam: false,
          zoom: 1.1,

          emphasis: {
            label: {
              color: '#fff',
              fontSize: 16,
              fontWeight:'bold'
            },
            itemStyle: {
              areaColor: '#77ebff',
              borderColor: '#77ebff',
              borderWidth: 2
            }
          },
          data: [
            { name: '北京', value: 17 },
            { name: '天津', value: 12 },
            { name: '上海', value: 15, selected: true },
            { name: '重庆', value: 15, selected: true },
            { name: '河北', value: 15 },
            { name: '河南', value: 15 },
            { name: '云南', value: 5 },
            { name: '辽宁', value: 15 },
            { name: '黑龙江', value: 15 },
            { name: '湖南', value: 2 },
            { name: '安徽', value: 15 },
            { name: '山东', value: 15, selected: true },
            { name: '新疆', value: 3 },
            { name: '江苏', value: 3, selected: true },
            { name: '浙江', value: 9, selected: true },
            { name: '江西', value: 15 },
            { name: '湖北', value: 4 },
            { name: '广西', value: 4 },
            { name: '甘肃', value: 10 },
            { name: '山西', value: 15 },
            { name: '内蒙古', value: 15 },
            { name: '陕西', value: 9 },
            { name: '吉林', value: 8 },
            { name: '福建', value: 9 },
            { name: '贵州', value: 9 },
            { name: '广东', value: 8 },
            { name: '青海', value: 3 },
            { name: '西藏', value: 9 },
            { name: '四川', value: 0 },
            { name: '宁夏', value: 15 },
            { name: '海南', value: 7 },
            { name: '台湾', value: 4 },
            { name: '香港', value: 4 },
            { name: '澳门', value: 3 }
          ]
        }],
        visualMap: [{
          type: 'piecewise',
          show: false,
          pieces: [
            { min: 0, max:4 },
            { min: 5, max: 8 },
            { min: 9, max: 11},
            { min: 12, max: 14},
            { min: 14},
          ],
          textStyle: {
            color: '#828994'
          },
          itemWidth: 64, // 每个图元的宽度
          itemHeight:12,
          top: "top",
          right: "0",
          inRange: {
            borderRadius: 4,
            color: [
              '#84bbff',
              '#70b4ff',
              '#61a7ff',
              '#56a0ff',
              '#4d90f2',
            ]
          },
        }],
        // tooltip: {
        //   trigger: 'item',  //数据项图形触发
        //   backgroundColor: "#fff",
        //   borderWidth: 0,
        //   formatter: '地区：{b}<br/>数据：{c}'
        // },
        toolbox: {
          show: false,
          orient: 'vertical',
          left: 'right',
          bottom: '0',
          feature: {
            restore: {},
            saveAsImage: {}
          }
        },
      });
    }
  }
}
</script>

<style lang="scss" scoped>
$box-height: 600px;
$box-width: 320px;
$box-loop-height: 240px;
#centerBottom {
  margin: 0 auto;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
  }

}
.grid-container {
  height: $box-loop-height;
}
.showFloor {
  display: flex;
  flex-direction: column;
}
.floorDevice {
  text-align: left;
  font-size: 18px;
  line-height: 18px;
  height: 18px;
  position: relative;
  top: 54px;
  left: 20px;
}
.room-loop {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  height: $box-loop-height;
  justify-content: space-evenly; /* Even spacing between the columns */
}
.room-card {
  flex: 1 0 40%; /* Flex-grow, Flex-shrink, Flex-basis */
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: rgb(249 249 249 / 12%)
}

.room-content {
  display: flex;
  text-align: center;
  width: 80%;
  height: 50px;
  line-height: 50px;
  justify-content: space-around;
  font-size: 26px;
  font-weight: 200;
  margin: 0 auto;
}
.room-text {
  width: 50%;
}
</style>
